import ConnectStayRating from 'components/StayRating';

const StayRating = ({ booking }) => (
  <ConnectStayRating booking={booking} width="100%" boxShadow="default" borderRadius="default" bg="white" px={[5, 6]} py={4} mb={[5, 8]} />
);

export default StayRating;
